import FormGroup from '@sportnet/ui/FormGroup';
import Col, { Row } from '@sportnet/ui/Grid';
import React from 'react';
import ReadOnlyTextArea from '../../../../../components/ReadOnlyTextArea';
import { __ } from '../../../../../utilities';
import { universalRequestDefinition } from '../../../definitions';
import Header from '@sportnet/ui/Header';
import Segment from '@sportnet/ui/Segment';

const AdminNote = ({ request }) => {
  if (!request.note) return null;
  return (
    <Segment raised>
      <Row>
        <Col m={6}>
          <Header size="s">{__('Poznámka admina: ')}</Header>
          <FormGroup>
            <ReadOnlyTextArea>{request.note}</ReadOnlyTextArea>
          </FormGroup>
        </Col>
      </Row>
    </Segment>
  );
};

AdminNote.propTypes = {
  request: universalRequestDefinition.isRequired,
};

export default AdminNote;
